import { useMutation } from "@apollo/client";

import { WorkerPool } from "types/generated";

import { UPDATE_WORKER_POOL } from "../gql";
import { CreateWorkerPoolFields } from "./types";
import { UNLIMITED_DRIFT_DETECTION_RUNS } from "./helpers";

const useEditWorkerPool = (refetchQuery?: string) => {
  const [updateWorkerPool] = useMutation<{ workerPoolUpdate: WorkerPool }>(UPDATE_WORKER_POOL, {
    ...(refetchQuery && { refetchQueries: [refetchQuery] }),
  });

  const onEdit = (formData: CreateWorkerPoolFields, workerPool: WorkerPool) => {
    return updateWorkerPool({
      variables: {
        id: workerPool.id,
        name: formData.name,
        description: formData.description,
        labels: formData.labels.map((item) => item.value),
        space: formData.space,
        driftDetectionRunLimit: formData.driftDetectionRunLimit ?? UNLIMITED_DRIFT_DETECTION_RUNS,
      },
    });
  };

  return { onEdit };
};

export default useEditWorkerPool;
